import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Context
import { AuthProvider } from './context/AuthContext';

// Components
import Layout from './components/Layout/Layout';
import PrivateRoute from './components/PrivateRoute';

// Pages
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import MahasiswaDashboard from './pages/Mahasiswa/MahasiswaDashboard';
import KRSMahasiswa from './pages/Mahasiswa/KRSMahasiswa';
import KHSMahasiswa from './pages/Mahasiswa/KHSMahasiswa';
import AKMMahasiswa from './pages/Mahasiswa/AKMMahasiswa';
import TagihanMahasiswa from './pages/Mahasiswa/TagihanMahasiswa';
import RiwayatPembayaran from './pages/Mahasiswa/RiwayatPembayaran';
import Students from './pages/Students/Students';
import StudentForm from './pages/Students/StudentForm';
import StudentDetail from './pages/Students/StudentDetail';
import KRS from './pages/KRS/KRS';
import KHS from './pages/KHS/KHS';
import AKM from './pages/AKM/AKM';
import Lecturers from './pages/Lecturers/Lecturers';
import Staff from './pages/Staff/Staff';
import Courses from './pages/Courses/Courses';
import CourseForm from './pages/Courses/CourseForm';
import NilaiTransfer from './pages/NilaiTransfer/NilaiTransfer';
import TranskripNilai from './pages/TranskripNilai/TranskripNilai';
import Kurikulum from './pages/Kurikulum/Kurikulum';
import Kelas from './pages/Kelas/Kelas';
import Users from './pages/Users/Users';
import NeoFeeder from './pages/NeoFeeder/NeoFeeder';
import ProfilPT from './pages/ProfilPT/ProfilPT';
import Profile from './pages/Profile';
import NotFound from './pages/NotFound';
import SettingPembiayaan from './pages/Finance/SettingPembiayaan';
import PembayaranMahasiswa from './pages/Finance/PembayaranMahasiswa';
import ManajemenKeuangan from './pages/Finance/ManajemenKeuangan';
import FormulirPendaftaran from './pages/PMB/FormulirPendaftaran';
import UserPMB from './pages/PMB/UserPMB';
import HalamanPMB from './pages/PMB/HalamanPMB';
import HalamanEditor from './pages/PMB/HalamanEditor';
import BerandaPMB from './pages/PMB/BerandaPMB';
import LoginPMB from './pages/PMB/LoginPMB';
import RegisterPMB from './pages/PMB/RegisterPMB';
import DashboardPMB from './pages/PMB/DashboardPMB';
import MaintenanceMahasiswa from './pages/Maintenance/MaintenanceMahasiswa';
import MaintenanceKelas from './pages/Maintenance/MaintenanceKelas';
import DashboardBAAK from './pages/BAAK/DashboardBAAK';
import BaakPembayaran from './pages/BAAK/BaakPembayaran';
import BaakTagihan from './pages/BAAK/BaakTagihan';
import BaakLaporan from './pages/BAAK/BaakLaporan';
import StatusPembayaran from './pages/BAAK/StatusPembayaran';
import BaakProposal from './pages/BAAK/BaakProposal';
import DashboardKemahasiswaan from './pages/Kemahasiswaan/DashboardKemahasiswaan';
import ProposalKegiatan from './pages/Kemahasiswaan/ProposalKegiatan';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            {/* PMB Public Routes */}
            <Route path="/pmb" element={<BerandaPMB />} />
            <Route path="/pmb/login" element={<LoginPMB />} />
            <Route path="/pmb/register" element={<RegisterPMB />} />
            <Route path="/pmb/dashboard" element={<DashboardPMB />} />
            
            <Route path="/login" element={<Login />} />
            
            <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
              <Route index element={<Navigate to="/dashboard" replace />} />
              <Route path="dashboard" element={<Dashboard />} />
              
              {/* Student Routes */}
              <Route path="students" element={<Students />} />
              <Route path="students/new" element={<StudentForm />} />
              <Route path="students/edit/:id" element={<StudentForm />} />
              <Route path="students/:id" element={<StudentDetail />} />
              
              {/* KRS & KHS Routes */}
              <Route path="krs" element={<KRS />} />
              <Route path="khs" element={<KHS />} />
              <Route path="akm" element={<AKM />} />
              
              {/* Mahasiswa Routes */}
              <Route path="mahasiswa/krs" element={<KRSMahasiswa />} />
              <Route path="mahasiswa/khs" element={<KHSMahasiswa />} />
              <Route path="mahasiswa/akm" element={<AKMMahasiswa />} />
              <Route path="mahasiswa/tagihan" element={<TagihanMahasiswa />} />
              <Route path="mahasiswa/pembayaran" element={<RiwayatPembayaran />} />
              
              {/* Lecturer Routes */}
              <Route path="lecturers" element={<Lecturers />} />
              
              {/* Staff Routes */}
              <Route path="staff" element={<Staff />} />
              
              {/* Course Routes */}
              <Route path="courses" element={<Courses />} />
              <Route path="courses/new" element={<CourseForm />} />
              <Route path="courses/edit/:id" element={<CourseForm />} />
              
              {/* Nilai Transfer Routes */}
              <Route path="nilai-transfer" element={<NilaiTransfer />} />
              
              {/* Transkrip Nilai Routes */}
              <Route path="transkrip-nilai" element={<TranskripNilai />} />
              
              {/* Kurikulum Routes */}
              <Route path="kurikulum/:prodi" element={<Kurikulum />} />
              
              {/* Kelas Routes */}
              <Route path="kelas" element={<Kelas />} />
              
              {/* Finance Routes */}
              <Route path="keuangan/setting-pembiayaan" element={<SettingPembiayaan />} />
              <Route path="keuangan/pembayaran-mahasiswa" element={<PembayaranMahasiswa />} />
              <Route path="keuangan/manajemen" element={<ManajemenKeuangan />} />
              
              {/* BAAK Routes */}
              <Route path="baak/dashboard" element={<DashboardBAAK />} />
              <Route path="baak/proposal" element={<BaakProposal />} />
              <Route path="baak/setting-pembayaran" element={<SettingPembiayaan />} />
              <Route path="baak/pembayaran" element={<BaakPembayaran />} />
              <Route path="baak/tagihan" element={<BaakTagihan />} />
              <Route path="baak/laporan" element={<BaakLaporan />} />
              <Route path="baak/status-pembayaran" element={<StatusPembayaran />} />
              
              {/* Kemahasiswaan Routes */}
              <Route path="kemahasiswaan/dashboard" element={<DashboardKemahasiswaan />} />
              <Route path="kemahasiswaan/proposal" element={<ProposalKegiatan />} />
              
              {/* PMB Routes */}
              <Route path="pmb/formulir-pendaftaran" element={<FormulirPendaftaran />} />
              <Route path="pmb/user" element={<UserPMB />} />
              <Route path="pmb/halaman" element={<HalamanPMB />} />
              <Route path="pmb/halaman/new" element={<HalamanEditor />} />
              <Route path="pmb/halaman/edit/:id" element={<HalamanEditor />} />
              
              {/* Profil PT Route */}
              <Route path="profil-pt" element={<ProfilPT />} />
              
              {/* NEO Feeder Routes */}
              <Route path="neofeeder" element={<NeoFeeder />} />
              
              {/* Maintenance Routes */}
              <Route path="maintenance/mahasiswa" element={<MaintenanceMahasiswa />} />
              <Route path="maintenance/kelas" element={<MaintenanceKelas />} />
              
              {/* User Routes */}
              <Route path="users" element={<Users />} />
              
              {/* Profile */}
              <Route path="profile" element={<Profile />} />
            </Route>
            
            <Route path="*" element={<NotFound />} />
          </Routes>
          
          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
